import { Skeleton, Stack } from "@mui/material";

const BarChartLoader =({height=300}:{height?:number}) => {
  const customWidth=height>300 ? (height-100): (height-50)
  return (
    <Stack
      spacing={1}
      width={"100%"}
      height={height}
      direction={"column"}
      justifyContent={"space-between"}
      px={2}
      py={3}
    >
   

      <Stack direction={"row"} spacing={2}>
        <Skeleton variant="rectangular" width={1} height={customWidth} />
        <Stack
         
          width={"80%"}
          height={customWidth}
        
          direction={"row"}
          spacing={5}
          alignItems={"flex-end"}
        >
          <Skeleton variant="rounded" width={50} height={200} />
          <Skeleton variant="rounded" width={50} height={100} />
          <Skeleton variant="rounded" width={50} height={120} />
          <Skeleton variant="rounded" width={50} height={200} />
          <Skeleton variant="rounded" width={50} height={100} />
          <Skeleton variant="rounded" width={50} height={120} />
          <Skeleton variant="rounded" width={50} height={200} />
          <Skeleton variant="rounded" width={50} height={120} />


          <Skeleton variant="rounded" width={50} height={90} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BarChartLoader;
